export const langAuthorizationInfo = {
  helpyou: {
    ua: 'Допоможе вам',
    en: 'It will help you',
  },
  paragraf1: {
    ua: 'Швидше сформулювати свою ціль і розпочати читати',
    en: 'Quickly formulate your goal and start reading',
  },
  paragraf2: {
    ua: 'Пропорційно розподілити навантаження на кожний день',
    en: 'Distribute the workload proportionally for each day',
  },
  paragraf3: {
    ua: 'Відстежувати особистий успіх',
    en: 'Track your personal success',
  },
  paragraf4: {
    ua: 'Також ви зможете',
    en: 'Also you can',
  },
  paragraf5: {
    ua: 'Формувати особисту думку незалежну від інших',
    en: 'Form your own opinion independently of others',
  },
  paragraf6: {
    ua: 'Підвищити свої професійні якості опираючись на нові знання',
    en: 'Improve your professional skills based on new knowledge',
  },
  paragraf7: {
    ua: 'Стати цікавим співрозмовником',
    en: 'Become an interesting conversationalist',
  },
  sign: {
    ua: 'Увійти',
    en: 'Sign in',
  },
  registr: {
    ua: 'Реєстрація',
    en: 'Registration',
  },
  regist: {
    ua: 'Зареєструватися',
    en: 'Register',
  },
  name: {
    ua: 'Ім’я',
    en: 'Name',
  },
  mail: {
    ua: 'Електронна адреса',
    en: 'E-mail address',
  },
  password: {
    ua: 'Пароль',
    en: 'Password',
  },
  confirm: {
    ua: 'Підтвердити пароль',
    en: 'Confirm password',
  },
  withUs: {
    ua: 'Вже з нами?',
    en: 'Already with us?',
  },
  wrong: {
    ua: 'Паролі не співпадають',
    en: 'Passwords do not match',
  },
  quote: {
    ua: 'Книги - морська глибина. Хто в них пірне аж до дна, той, хоч і труду мав досить, дивнії перли виносить.',
    en: 'Books are the depth of the sea, those who dive to the bottom, despite the efforts they have to bear, bring back strange pearls.',
  },
  author: {
    ua: 'І. Франко',
    en: 'I. Franko',
  },
};
